import {ERROR, HTTP} from '@/http-common';
import Router from '@/router';
import Vue from 'vue';

const state = {
  errorBag: [],
  accountsList: {
    accounts: []
  },
  account: {
    data: {
      serviceCategory: 'Other',
    },
    status: 'Activate',
    accountType: 'default',
    twilioStatus: '0',
    twoFactorAuthEnabled: false
  },
  accountFromServer: {
    data: {
      serviceCategory: 'Other',
    },
    status: 'Activate',
    accountType: 'default',
    twilioStatus: '0',
  },
  parentAccount: null,
  user: {},
  userAccess: {
    rows: [],
    name: ''
  },
};

const mutations = {
  SET_ACCOUNTS(state, accountsList) {
    accountsList.accounts = _.map(accountsList.accounts, (item) => {
      if (item.hasOwnProperty('twilioStatus')) {
        item.twilioStatus ? item.twilioStatus = 'Active' : item.twilioStatus = 'Disabled'
      }
      return item;
    });

    state.accountsList = accountsList;
  },
  SET_ACCOUNT(state, accountData) {
    state.account = accountData;
  },
  SET_ACCOUNT_FROM_SERVER(state, accountData) {
    state.accountFromServer = accountData;
  },
  SET_ACCESS(state, access) {
    state.user.access = access;
  },
  SET_ERROR_BAG(state, data) {
    state.errorBag = data;
  },
  PUSH_ERROR_BAG(state, data) {
    state.errorBag.push(data);
  },
  RESET_USER(state) {
    state.user = {};
  },
  RESET_ACCOUNT(state) {
    state.account = JSON.parse(JSON.stringify({
      data: {
        serviceCategory: 'Other'
      },
      status: 'Active',
      accountType: 'default',
      twilioStatus: '0',
    }));
    state.parentAccount = null;
  },
  SET_PARENT_ACCOUNT(state, accountData) {
    state.parentAccount = accountData;
  },
  SET_USER_ACCESS(state, data) {
    state.userAccess = data;
  }
};

const getters = {
  accountsList: state => state.accountsList,
  account: state => state.account,
  accountFromServer: state => state.accountFromServer,
  accountErrorBag: state => state.errorBag,
  currentUser: state => state.user,
  parentAccount: state => state.parentAccount,
  getUserAccess: state => state.userAccess
};

const actions = {
  GET_ACCOUNTS_ACTION: ({commit}) => {
    HTTP.get(`accounts`)
      .then(response => {
        if (response.data.status === 'success') {
          commit('SET_ACCOUNTS', response.data.data);
        }
        ERROR(response);
      }).catch(err => {
      console.log(err);
    })
  },
  SEARCH_ACCOUNTS_ACTION: ({commit}, payload) => {
    payload.context.start();
    HTTP.post(`accounts`, {search: payload.q})
      .then(response => {
        if (response.data.status == 'success') {
          commit('SET_ACCOUNTS', response.data.data);
          payload.context.stop();
        }
        ERROR(response);
      }).catch(err => {
      payload.context.stop();
      console.log(err);
    })
  },
  GET_ACCOUNT_ACTION: ({commit}, payload) => {
    commit('RESET_USER');
    HTTP.get(`accounts/edit/${payload}`)
      .then(response => {
        if (response.data.status === 'success') {
          const account = response.data.data.account;
          commit('SET_ACCOUNT', account);
          commit('SET_ACCOUNT_FROM_SERVER', account);
        }
        ERROR(response);
      }).catch(err => {
      console.log(err);
    })
  },
  ADD_ACCOUNT_ACTION: ({commit, dispatch}, context) => {
    context.start();
    HTTP.post(`accounts/create`, state.account)
      .then(response => {
        if (response.data.status == 'success') {
          dispatch('GET_ACCOUNT_ACTION', response.data.data.id);
          Router.push({name: 'Manage Account Edit CaseMGR', params: {casemgrid: response.data.data.id}});
          Vue.prototype.$notify(response.data.data.message);
        } else {
          commit('SET_ERROR_BAG', response.data.data.errors.data);
          Vue.prototype.$notify({
            type: 'error',
            text: 'Correct form errors.'
          });
        }
        context.stop();
        ERROR(response);
      }).catch(err => {
      context.stop();
      console.log(err);
    })
  },
  ADD_USER_ACTION: ({commit, dispatch}, payload) => {
    payload.context.start();
    commit('SET_ACCESS', payload.access);
    HTTP.post(`accounts/create/${state.account.id}`, state.user)
      .then(response => {
        if (response.data.status == 'success') {
          Vue.prototype.$notify('User added.');
          dispatch('GET_ACCOUNT_ACTION', state.account.id);
          commit('RESET_USER');
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        payload.context.stop();
        ERROR(response);
      }).catch(err => {
      payload.context.stop();
      console.log(err);
    })
  },
  SAVE_ACCOUNT_ACTION: ({commit, dispatch}, payload) => {
    payload.context.start();
    HTTP.post(`accounts/edit/${payload.id}`, {
      HIPAARegulated: state.account.HIPAARegulated,
      organizationName: state.account.organizationName,
      status: state.account.status,
      data: state.account.data,
      twilioPhone: state.account.twilioPhone,
      twilioStatus: state.account.twilioStatus,
      participantType: state.account.participantType,
      participantDisplayName: state.account.participantDisplayName,
      usersLimit: state.account.usersLimit,
      expirationDate: state.account.expirationDate,
      accountType: state.account.accountType,
      searchInOrganizations: state.account.searchInOrganizations,
      twoFactorAuthEnabled: state.account.twoFactorAuthEnabled
    })
      .then(response => {
        if (response.data.status == 'success') {
          Vue.prototype.$notify(response.data.data.message);
          dispatch('GET_USER_DATA_REFRESH_ACTION');
        } else {
          commit('SET_ERROR_BAG', response.data.data.errors);
        }
        ERROR(response);
        payload.context.stop();
      }).catch(err => {
      console.log(err);
      payload.context.stop();
    })
  },
  RESEND_ACTIVATION_ACCOUNT_ACTION: ({commit}, payload) => {
    Vue.prototype.$notify({
      type: 'warning',
      text: 'Sending request...'
    });
    HTTP.post(`/accounts/${state.account.id}/resend/${payload}`)
      .then(response => {
        if (response.data.status == 'success') {
          Vue.prototype.$notify(response.data.data.message);
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        ERROR(response);
      }).catch(err => {
      console.log(err);
    })
  },
  TOGGLE_ACTIVATION_ACCOUNT_ACTION: ({commit, dispatch}, payload) => {
    Vue.prototype.$notify({
      type: 'warning',
      text: 'Sending request...'
    });
    HTTP.post(`/accounts/${state.account.id}/toggle/${payload}`)
      .then(response => {
        if (response.data.status == 'success') {
          dispatch('GET_ACCOUNT_ACTION', state.account.id);
          Vue.prototype.$notify(response.data.data.message);
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        ERROR(response);
      }).catch(err => {
      console.log(err);
    })
  },
  RESET_ACCOUNT_ACTION: ({commit}) => {
    commit('RESET_ACCOUNT');
  },
  SET_PARENT_ACCOUNT_ID_ACTION: ({commit}, payload) => {
    HTTP.get(`accounts/edit/${payload}`)
      .then(response => {
        if (response.data.status == 'success') {
          let newChildAccount = {};

          newChildAccount.data = response.data.data.account.data;
          newChildAccount.organizationName = '';
          newChildAccount.twilioStatus = 0;
          newChildAccount.twilioPhone = '';
          newChildAccount.parentId = response.data.data.account.id;
          newChildAccount.participantType = response.data.data.account.participantType;
          newChildAccount.accountType = 'child';
          newChildAccount.twoFactorAuthEnabled = response.data.data.account.twoFactorAuthEnabled;

          commit('SET_ACCOUNT', newChildAccount);
          commit('SET_PARENT_ACCOUNT', response.data.data.account);
        }
        ERROR(response);
      }).catch(err => {
      console.log(err);
    })
  },
  UNLINK_ACCOUNT_ACTION: ({commit, dispatch}, payload) => {
    HTTP.post(`/accounts/unlink-account`, payload)
      .then(response => {
        if (response.data.status == 'success') {
          dispatch('GET_ACCOUNT_ACTION', state.account.id);

          Vue.prototype.$notify(response.data.data.message);
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        ERROR(response);
      }).catch(err => {
      console.log(err);
    })
  },
  loadUserAccess: ({commit}, userId) => {
    return HTTP.get('/accounts/user-access/'+userId).then(response => {
      if(response.data.status === 'success') {
        commit('SET_USER_ACCESS', response.data.data)
      } else {
        commit('SET_USER_ACCESS', []);
      }
    }).catch(err => {
      console.log(err);
    })
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/manageAccount.js